<template>
    <div class="card-panel">
        <div class="card-body">
            <h4> Device Infomation </h4>
            <div class="form-group">
                <p class="title-label text-gray">Model Name:</p> {{mdoeName}}
            </div>
            <div class="form-group">
                <p class="title-label text-gray">Mac-Address:</p> {{mac}}
            </div>
            <div class="form-group">
                <p class="title-label text-gray">Hardware Version:</p> {{hardwareVersion}}
            </div>
            <div class="form-group">
                <p class="title-label text-gray">Firmware Version:</p> {{softwareVersion}}
            </div>
            <div class="form-group">
                <p class="title-label text-gray">System Uptime:</p> {{systemTime}}
            </div>
            <div class="form-group">
                <p class="title-label text-gray">CPU Usage :</p>
                <div class="progress progress-striped active clear small">
                    <div class="progress-bar" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" :style="'width:' + cpu">
                        <span class="sr-only">{{cpu}} Complete</span>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <p class="text-gray">Memory Usage :</p>
                <div class="progress progress-striped active clear small">
                    <div class="progress-bar" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" :style="'width:'+ memory">
                        <span class="sr-only">{{memory}} Complete</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer border-top"><button class="card-btn green"  @click="reboot">Reboot</button></div>
    </div>
</template>

<script>
import Reboot from '@/components/reboot.js'


export default {
    data() {
        return {
            mdoeName: "",
            mac:"",
            hardwareVersion:"",
            softwareVersion:"",
            memory:"0%",
            cpu:"0%",
            systemTime:"0day:0h:0m:0s",
            setIntervalId:0
        }
    },
    created:function (){
        axios
        .post("/boafrm/getBaseInfo")
        .then((response)=>{
            this.mdoeName = response.data.productType
            this.mac = response.data.mac
            this.hardwareVersion = response.data.hardwareVersion
            this.softwareVersion = response.data.softwareVersion
            this.memory = response.data.memory
            this.systemTime = response.data.systemTime
            this.cpu =  (100 - parseInt(response.data.cpu)) + "%"
        })
        this.getDeviceInfo()
        
    },
    beforeDestroy:function () { 
        clearInterval(this.setIntervalId)
    },
    methods:{
        reboot(){
            this.$confirm("Are you sure you want to restart your device?","Tips",{type:'warning'})
                .then(()=>{
                    clearInterval(this.setIntervalId)
                    Reboot.init(this)
                })
        },
        getDeviceInfo() {
           
            if(this.setIntervalId === 0)
            {// 方式重复调用查询
                // 每10s查询一次
                this.setIntervalId = setInterval(() => { 
                    axios
                    .post("/boafrm/getBaseInfo")
                    .then((response)=>{
                        this.mdoeName = response.data.productType
                        this.mac = response.data.mac
                        this.hardwareVersion = response.data.hardwareVersion
                        this.softwareVersion = response.data.softwareVersion
                        this.memory = response.data.memory
                        this.cpu =  (100 - parseInt(response.data.cpu)) + "%"
                    })
                }, 5000);
            }
            
        }
    }
}
</script>




